<div class="popup-message" [ngClass]="{'active': active,'popup-message__success': popupData.success, 'popup-message__error': popupData.error}">
    <h4 [innerHtml]="popupData.message"></h4>
</div>
